'use strict';

let BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

BaseAxisDirective=class BaseAxisDirective extends BaseControllerBackedDirective{
get objectBindings(){return['domain','plotArea','myself','offset']}
get textBindings(){return['orientation']}
get controller(){throw new Error('abstract')}};


module.exports=BaseAxisDirective;
//# sourceMappingURL=baseAxisDirective.js.map
